<template>
  <div>
    <div class="timeline-left wp-50">
      <h6 class="sub-head m-0">{{$t('INDENT_INDENT_TIMELINE')}}</h6>
      <Timeline class="timeline-default mt-10 timeline-with-action">
        <TimelineItem v-for="(event, idx) in eventsArray" :key="idx+event.time" placement="top" :class="getClass(event)">
          <OrderTimeLineItem
            :event="event"
            :order="order"
            :timeFormat="timeFormat" />
        </TimelineItem>
        <TimelineItem v-if="order && order.flow && order.flow.rfq_comment" timestamp="-" placement="top"
          class="dot-purple">
          <h4>{{$t('INDENT_RFQ_REMARK')}}</h4>
          <p>{{order.flow.rfq_comment}}</p>
        </TimelineItem>
      </Timeline>
    </div>
    <div class="timeline-right wp-50 position-card">
    <div v-if="isLrLoading">
      <Spinner />
    </div>

    <div v-else>

    <div v-if="isPackingIndentEnabled && !isIntegratedCarrierAvailable && !isShipped">
      <div v-if="!isFetchOpen" class="field-editable is-select">
        <label>{{$t('INDENT_TRACKING_NUMBER')}}</label>
        <Input
          :placeholder="$t('INDENT_ADD_TRACKING_NUMBER')"
          size="mini"
          class="input-blank p-0"
          :value="trackingVal"
          v-model="tracking_no"
          @focus="showEditIconsView"
        />
        <div class="action-edit" v-if="showEditIcons">
          <i class="text-grey-medium" @click="clearTrackingNo(order)">
            <svgicon name="icon-close" width="8" height="8" />
          </i>
          <i class="text-blue" @click="saveTrackingNo(order)">
            <svgicon name="icon-tick-sm" width="10" height="10" />
          </i>
        </div>
      </div>
    </div>

    <div v-else-if="isPackingIndentEnabled && !isIntegratedCarrierAvailable && isShipped && !isFetchOpen">
      <h6 class="mb-10">{{$t('INDENT_TRACKING_NUMBER')}}</h6>
      <span>
        <span class="mb-10"> {{trackingVal}}</span>
      </span>
    </div>

    <div v-else-if="trackingList && isPackingIndentEnabled">
      <div v-if="isPackingIndentEnabled && !isConsignmentTrackLoading && order.indent_category === 3 && !isFetchOpen">
        <h6 class="mb-10">{{$t('INDENT_LR_STATUS_TIMELINE')}}</h6>
        <div class="timeline-detail" :key="trackingList.master_tracking_number">
          <span>
            <span>{{trackingList.master_tracking_number}}</span>
            <small>{{trackingList.carton_id}}</small>
          </span>
          <span>
            <span>{{trackingList.last_tracking_status}}</span>
            <span>{{trackingList.last_tracking_date}}</span>
          </span>
          <span class="action-btn text-right">
            <a href="javascript:void(0)" class="link-action" @click="fetchTracking({
            tracking_id: trackingList.master_tracking_number,
            carton_id: trackingList.carton_id,
            last_tracking_status: trackingList.last_tracking_status,
            last_tracking_date: trackingList.last_tracking_date
            })">
              <svgicon name="icon-fetch" width="12" height="12" :original="true" /> Fetch
            </a>
          </span>
          <div class="row-expand" v-on:click="accordian" v-bind:class="{'is-toggle': isActive}">
          </div>
        </div>
        <div class="nested-list" v-if="isActive">
          <!-- timeline-detail -->
          <div class="timeline-detail" v-for="consignment in trackingList.child_details"
            :key="consignment.tracking_id">
            <span>
              <span>{{consignment.tracking_id}}</span>
              <small>{{consignment.carton_id}}</small>
            </span>
            <span>
              <span>{{consignment.last_tracking_status}}</span>
              <span>{{consignment.delivery_date || consignment.last_tracking_date}}</span>
            </span>
            <span class="action-btn text-right">
              <a href="javascript:void(0)" class="link-action" @click="fetchTracking(consignment)">
                <svgicon name="icon-fetch" width="12" height="12" :original="true" /> Fetch
              </a>
            </span>
          </div>
        </div>
      </div>
    </div>

    <!-- start of NON HACH courier Tracking Timeline -->
    <!-- start of retrigger data -->
    <div v-else-if="order.indent_category !== 3 && isCourierServiceEnabled &&
       (trackingList &&  trackingList.retriggerData && trackingList.transporterBookings
       && (trackingList.retriggerData.length || trackingList.transporterBookings.length))">
      <div v-if="!isFetchOpen">
        <h6 class="mb-10">{{$t('INDENT_LR_STATUS_TIMELINE')}}</h6>
        <div class="timeline-detail" v-for="consignment in trackingList.retriggerData"
         :key="consignment.id">
          <span class="pl-10">
            {{consignment.reference_id}}
          </span>
          <span v-if="consignment.waiting_transporter_response" class="text-sm">
           {{$t('INDENT_IN_PROGRESS')}}
          </span>
          <span v-else class="text-sm text-red3">
            {{$t('INDENT_BOOKING_FAILED')}}
          </span>
          <span v-if="consignment.waiting_transporter_response" class="text-info ml-auto">
            {{$t('INDENT_PLEASE_WAIT')}}<br>{{$t('INDNET_AWAITING_UPDATE_TRANSPORTER')}}
          </span>
          <span  v-else-if="!isDispatched && !isCourierEnabled" class="action-btn">
            <a href="javascript:void(0)" class="link-action" @click="retriggerBooking(consignment)">
              <svgicon name="icon-re-indent" width="10" height="10" :original="true" /> {{$t('INDENT_RETRIGGER')}}
            </a>
          </span>
        </div>

        <!-- start of courier fetching data -->
        <div v-if="!isConsignmentTrackLoading">
          <div v-for="(transporterBookings, index) in ((this.trackingList && this.trackingList.transporterBookings) || [])"
           :key="index">
              <div class="timeline-card" v-for="trackingData in transporterBookings.tracking_data"
                :key="trackingData.tracking_id">
                    <div class="flex-container panel-head align-item-base mb-0 ml-5">
                      <div class="flex-item">
                        <p class="m-0">
                          <strong>
                            {{trackingData.booking_id}}
                          </strong>
                        </p>
                        <p class="my-5 text-xs text-grey-dark1"> {{trackingData.tracking_id}}  </p>
                      </div>
                      <div class="flex-item mr-10">
                        <p class="my-5" :class="getClassName(trackingData)"><strong> {{getBookingStatus(trackingData)}} </strong></p>
                        <p v-if="!isBookingCancelled(trackingData)" class="my-5 text-xs text-grey-dark1"> {{trackingData.last_tracking_date || '-'}} </p>
                      </div>
                      <div v-if="!isBookingCancelled(trackingData)" class="flex-item mr-5">
                        <span class="action-btn text-right">
                          <a href="javascript:void(0)" class="link-action" @click="fetchTracking(trackingData)">
                            <svgicon name="icon-fetch" width="12" height="12" :original="true" /> Fetch
                          </a>
                        </span>
                      </div>
                    </div>

                    <div class="flex-container panel-head align-item-base mb-5 ml-5" v-if="LorryReceiptGenerationCategory.LEGAL_ENTITY_WISE === lrCategory">
                      <div class="flex-item">
                        <p class="mb-0" :class="getClassName(trackingData)">
                          <strong> {{parseLegalEntity(trackingData)[0]}} </strong>
                        </p>
                      </div>
                      <div class="flex-item mr-10">
                          <p class="mb-0" :class="getClassName(trackingData)">
                            <strong>{{parseLegalEntity(trackingData)[1]}}</strong>
                          </p>
                      </div>
                    </div>
                    <div class="flex-container panel-head align-item-base mb-5 ml-5" v-else-if="LorryReceiptGenerationCategory.CONSIGNEE_WISE === lrCategory">
                      <div class="flex-item">
                        <p class="mb-0" :class="getClassName(trackingData)">
                          <strong> {{trackingData.consignee_name || '-'}} </strong>
                        </p>
                      </div>
                      <div class="flex-item mr-10">
                          <p class="mb-0" :class="getClassName(trackingData)">
                            <strong>{{trackingData.consignee_reference_id || '-'}}</strong>
                          </p>
                      </div>
                    </div>
                    <div class="flex-container panel-head align-item-base mb-5 ml-5" v-else-if="LorryReceiptGenerationCategory.GATE_WISE === lrCategory">
                      <div class="flex-item">
                        <p class="mb-0" :class="getClassName(trackingData)">
                          <strong> {{trackingData.source_name || '-'}} </strong>
                        </p>
                      </div>
                      <div class="flex-item mr-10">
                          <p class="mb-0" :class="getClassName(trackingData)">
                            <strong>{{trackingData.consignee_reference_id || '-'}}</strong>
                          </p>
                      </div>
                    </div>
                    <div class="flex-container panel-head align-item-base mb-5 ml-5" v-else-if="LorryReceiptGenerationCategory.DIVISION_WISE === lrCategory">
                      <div class="flex-item">
                        <p class="mb-0" :class="getClassName(trackingData)">
                          <strong> {{trackingData.division || '-'}} </strong>
                        </p>
                      </div>
                      <div class="flex-item mr-10">
                          <p class="mb-0" :class="getClassName(trackingData)">
                            <strong>{{trackingData.consignee_reference_id || '-'}}</strong>
                          </p>
                      </div>
                    </div>
              </div>
          </div>
        </div>
      </div>
      <!--Start of Actual courier Tracking  when user clicks on Fetch button -->
      <div v-if="isFetchOpen === 'tracking'">
        <h4 class="pointer" @click="backToListing()">
          <svgicon name="left_arrow" width="16" height="11" />
          {{currentTrackingId}}
        </h4>
        <div class="status-msg" v-if="isConsignmentTrackLoading">
          <span>
            <img :src="Timeline" width="200" height="150" alt=""/>
          </span>
        </div>
        <div v-else-if="consignmentTrackingList && consignmentTrackingList.length">
          <!-- Loop courier tracking response  -->
           <Timeline class="timeline-default mt-10 timeline-with-action">
            <TimelineItem v-for="(event, idx) in consignmentTrackingEvents" :key="idx+event.time" placement="top" class="dot-green mb-5">
              <OrderTimeLineItem
                :event="event"
                :order="order"
                :timeFormat="timeFormat" />
            </TimelineItem>
          </Timeline>
        </div>
        <div v-else-if="!isConsignmentTrackLoading">
               {{$t('INDENT_TRACKING_HISTORY_EMPTY')}}
        </div>

      </div>

    </div>

    <div v-else-if="showConsignmentMessage && !isFetchOpen">
      <h6 class="mb-10">{{$t('INDENT_LR_STATUS_TIMELINE')}}</h6>
      {{$t('INDENT_NO_CONSIGNMENT_NUMBERS')}}
      {{$t('INDENT_INVALID_CONSIGNMENT_NUMBER')}}
    </div>

    <div v-if="order.approval_event_type">
      <h6 v-if="!isFetchOpen" class="mb-10">{{$t('INDENT_APPROVAL_TIMELINE')}}</h6>

      <div v-if="!isFetchOpen">
        <div class="flex-container panel-head align-item-base mb-0 ml-5">
          <div class="flex-item">
            <p class="m-0">
              <strong> {{ ApprovalEvent[order.approval_event_type] }} </strong>
            </p>
          </div>
          <div class="flex-item mr-5">
            <span class="action-btn text-right">
              <a href="javascript:void(0)" class="link-action"
                @click="fetchApprovalTimeline()">
                <svgicon name="icon-fetch" width="12" height="12" :original="true" /> Fetch
              </a>
            </span>
          </div>
        </div>
      </div>

      <div v-if="isFetchOpen === 'approvals'">
        <h4 class="pointer" @click="backToListing()">
          <svgicon name="left_arrow" width="16" height="11" />
          {{$t(eventType)}}
        </h4>
        <div class="status-msg" v-if="isApprovalDataLoading">
          <span>
            <img :src="Timeline" width="200" height="150" alt=""/>
          </span>
        </div>
        <div v-if="approvalList && approvalList.length">
           <Timeline class="timeline-default mt-10 timeline-with-action">
            <TimelineItem v-for="(event, idx) in approvalList" :key="idx+event.time"
              placement="top"
              :class="(event.status === RFQConstants.ApprovalStatus.REJECTED) ? 'dot-red' : 'dot-green'"
              class="mb-5">
              <OrderTimeLineItem
                :event="event"
                :order="order"
                :timeFormat="timeFormat" />
            </TimelineItem>
          </Timeline>
        </div>
        <div v-else-if="!isApprovalDataLoading">
               {{$t('INDENT_NO_DOCUMENT_DATA')}}
        </div>

      </div>

      <!-- end -->

    </div>

    </div>
    </div>
  </div>
</template>
<script>
import { uniqBy, orderBy, uniq, groupBy, cloneDeep, isEmpty, invert } from 'lodash';
import { mapGetters } from 'vuex';
import Timeline from '@common/asset/images/Indent.gif';
import moment from 'moment';
import OrderTimeLineItem from './OrderTimeLineItem';
import { LorryReceiptGenerationCategory, ApprovalConstants, RFQConstants, ApprovalEvent, roles, timelineActionType, courierServiceAction, indentMessage } from 'pando-constants';


export default {
  components: { OrderTimeLineItem },
  props: ['order', 'hideGateDetails', 'timeFormat', 'integrationTimeLine', 'changeTruckComments'],
  data() {
    return {
      trackingVal: null,
      tracking_no: '',
      Timeline,
      isFetchOpen: null,
      currentTrackingId: null,
      isActive: false,
      isShipped: false,
      activeConsigneeId: null,
      showEditIcons: false,
      transporterChangeHistory: [],
      LorryReceiptGenerationCategory,
      sectionType: { DEPOT: 1 },
      orderDetails: this.order,
      legalEntityDetails: {},
      isLrLoading: false,
      eventType: null,
      approvalList: [],
      ApprovalConstants,
      RFQConstants,
      ApprovalEvent,
      courierServiceAction,
      indentMessage,
    };
  },
  async created() {
    this.isLrLoading = true;
    await this.fetchCourierTrackingList();
    this.trackingVal = this.order.label_details && this.order.label_details.tracking_number;
    this.tracking_no = this.trackingVal;
    this.isShipped = this.editTrackinNumber();
    this.isLrLoading = false;
  },
  mounted() {
    this.fetchTransporterChangeHistory();
  },
  computed: {
    ...mapGetters({
      vehicleList: 'routes/openVehicles',
      trackingList: 'order/trackingList',
      consignmentTrackingList: 'order/consignmentTrackingList',
      isConsignmentTrackLoading: 'order/isConsignmentTrackLoading',
      isApprovalDataLoading: 'order/isApprovalDataLoading',
      otherUserDepots: 'app/otherDepots',
      configurations: 'app/configurations',
      currentUserDepots: 'app/depots',
    }),
    multiDropAtGateLevel() {
      return this.configurations && this.configurations.multi_drop_at_gate_level;
    },
    lrCategory() {
      return (this.order && this.order.lr_type) ||
       (this.configurations && this.configurations.lorry_receipt_generate_category);
    },
    showTrackingNo() {
      return this.tracking_no;
    },
    isDispatched() {
      const currOrderStatus = this.order.status;
      return (
        this.$statusUtil.isDispatched(currOrderStatus) ||
        this.$statusUtil.isAfterDispatched(currOrderStatus)
      );
    },
    showConsignmentMessage() {
      return (!this.trackingList || (this.trackingList.transporterBookings
      && this.trackingList.retriggerData
      && !this.trackingList.transporterBookings.length
      && !this.trackingList.retriggerData.length)) &&
        (this.order && this.order.meta && this.order.meta.courier) &&
        this.order.meta.courier.add_manual_consignment_number;
    },
    isPackingIndentEnabled() {
      return this.$hasFeature('packing_indent');
    },
    isCourierEnabled() {
      return this.$hasFeature('view_courier_integrations');
    },
    isIntegratedCarrierAvailable() {
      return !!(this.order && this.order.meta &&
      this.order.meta.courier && this.order.meta.courier.service_id);
    },
    isCourierServiceEnabled() {
      return !!(this.order && this.order.meta &&
      this.order.meta.courier && this.order.meta.courier.enabled);
    },
    consignmentTrackingEvents() {
      return this.consignmentTrackingList.map(event => ({
        type: event.activity,
        time: event.date_time,
        name: event.location,
        pincode: event.location_pincode,
        remarks: event.remarks,
      }));
    },
    getTransporterComments() {
      if (this.order.rejectedTransporterComments.length) {
        const commentsMapper = {};
        this.order.rejectedTransporters.forEach((transporter, index) => {
          commentsMapper[transporter] = this.order.rejectedTransporterComments[index];
        });
        return commentsMapper;
      }
      return {};
    },
    eventsArray() {
      const time = [];
      const currOrder = JSON.parse(JSON.stringify(this.order));
      const loadingDate = (currOrder.sources && currOrder.sources.length && currOrder.sources[0].loading_date) || null;
      time.push({
        type: this.$t('INDENT_INDENT_CREATED'),
        time: this.order && this.order.created_at ? this.order.created_at : null,
      });
      if (this.order && this.order.timelines && this.order.timelines.indent_accepted_at) {
        time.push({ id: 'INDENT_ACCEPTED', type: this.$t('INDENT_INDENT_ACCEPTED'), time: this.order.timelines.indent_accepted_at, name: `By ${currOrder.transporter.name}` });
      }
      if (this.order && this.order.timelines && this.order.timelines.moved_to_dock_at) {
        time.push({ type: this.$t('INDENT_MOVED_TO_DOCK'), time: this.order.timelines.moved_to_dock_at });
      }
      if (this.order && this.order.timelines && this.order.timelines.handover_completed_at) {
        time.push({ type: this.$t('INDENT_HANDOVER_COMPLETE'), time: this.order.timelines.handover_completed_at });
      }
      if (this.order && this.order.timelines && this.order.timelines.moved_back_to_indented) {
        time.push({ type: this.$t('INDENT_MOVED_BACK_TO_INDENTED'), time: this.order.timelines.moved_back_to_indented });
      }
      if (this.order && this.order.timelines && !isEmpty(this.order.timelines.vehicle_types)) {
        this.order.timelines.vehicle_types.forEach((changeHistory) => {
          const { type, user } = switchVehicleTypeEvent(changeHistory);
          time.push({
            type: this.$t(type),
            name: changeHistory.name,
            time: changeHistory.date_on,
            updated_by: this.$t(user, { updatedBy: changeHistory.user }),
          });
        });
      }
      function switchVehicleTypeEvent(changeHistory) {
        let type;
        let user;
        switch (changeHistory.action) {
          case timelineActionType.REQUEST:
            type = 'INDENT_VEHICLE_TYPE_REQUEST';
            user = 'INDENT_VEHICLE_TYPE_REQUESTED_BY';
            break;
          case timelineActionType.APPROVAL:
            type = 'INDENT_VEHICLE_TYPE_APPROVE';
            user = 'INDENT_VEHICLE_TYPE_APPROVED_BY';
            break;
          default:
            type = 'INDENT_VEHICLE_TYPE_CHANGE_HISTORY';
            user = 'INDENT_TRANSPORTER_UPDATED_BY';
            break;
        }
        return { type, user };
      }
      if (loadingDate) {
        const type = this.$hasFeature('packing_indent') ?
          this.$t('INDENT_SCHEDULED_SHIPPING_DATE') : this.$t('INDENT_VEHICLE_REQUIREMENT_DATE');
        time.push({ type, time: loadingDate });
      }
      let secondaryVehicle = null;
      let epodDeletionData = null;
      let courierConsigneeDelivery = null;
      let vehicleTypeChanged = null;
      if (currOrder && currOrder.flow) {
        secondaryVehicle = currOrder.flow.secondary_vehicle_type;
        epodDeletionData = currOrder.flow.epod_deletion_data;
        courierConsigneeDelivery = currOrder.flow.courier_consignee_delivery;
        vehicleTypeChanged = currOrder.flow.vehicle_type_changed;
      }

      if (secondaryVehicle && secondaryVehicle.id) {
        const vehicleName =
          this.vehicleList.find(vehicle => vehicle.id === secondaryVehicle.id)
            .name || this.$t('INDENT_NO_EXIST');
        time.push({
          type: this.$t('INDENT_VEHICLE_CHANGED'),
          time: currOrder.flow.secondary_vehicle_type.modified_date,
          name: vehicleName || this.$t('INDENT_NO_EXIST'),
        });
      }

      if (epodDeletionData && epodDeletionData.length) {
        epodDeletionData.forEach((data) => {
          time.push({
            type: this.$t('INDENT_GATE_OR_DESTINATION_DELETION'),
            time: data.deleted_at,
            name: data.reason || '',
          });
        });
      }

      if (courierConsigneeDelivery && courierConsigneeDelivery.delivered_at) {
        time.push({
          type: this.$t('INDENT_ALL_CONSIGNMENT_DELIVERED'),
          time: courierConsigneeDelivery.delivered_at,
          name: courierConsigneeDelivery.reason || '',
        });
      }

      if (vehicleTypeChanged && vehicleTypeChanged.changed_at) {
        time.push({
          type: this.$t('INDENT_VEHICLE_TYPE_CHANGED'),
          time: vehicleTypeChanged.changed_at,
          name: vehicleTypeChanged.reason || '',
        });
      }

      if (currOrder && currOrder.previous_transporters &&
        currOrder.previous_transporters.length) {
        currOrder.previous_transporters.forEach((_transporter) => {
          const transporter = _transporter.previous_transporter;
          const assignTransporter = _transporter.assigned_transporter;
          if (transporter.rejected_at || transporter.breached_at) {
            let text = '';
            if (transporter.rejected_at) {
              if (assignTransporter && assignTransporter.name) {
                text = `${transporter.name} - ${transporter.ref_id || ''}`;
              } else {
                text = `${transporter.name} - ${transporter.ref_id || ''} has rejected the indent`;
              }
            }
            if (transporter.breached_at) {
              text = `By ${transporter.name} - ${transporter.ref_id || ''}`;
            }
            if (assignTransporter && assignTransporter.name) {
              text += ` assigned to ${assignTransporter.name} - ${assignTransporter.ref_id}`;
            }

            let slaBreachText = transporter.comment;
            if (!slaBreachText && this.order.sla_breach) {
              slaBreachText = 'SLA Arrival Breach';
            } else if (!slaBreachText && this.order.acceptance_sla_breach) {
              slaBreachText = 'SLA Acceptance Breach';
            }
            time.push({
              id: 'ACCEPTANCE_SLA',
              color: 'red',
              type: transporter.breached_at ? slaBreachText : this.$t('INDENT_INDENT_REJECTED_BY'),
              name: text,
              reason: !transporter.breached_at ? (this.getTransporterComments[transporter.name] || '') : '',
              time: transporter.rejected_at
                ? transporter.rejected_at
                : transporter.breached_at,
              updated_by: transporter.rejected_at ? this.$t('REJECTED_BY_TRANSPORTER_USER')
                : this.$t('INDENT_TRANSPORTER_UPDATED_BY', {
                updatedBy: roles.SYSTEM
              }),
            });
          }
          if (assignTransporter && assignTransporter.bid_accepted) {
            time.push({
              type: this.$t('INDENT_RFQ_ACCEPTED'),
              name: this.$t('INDENT_ALLOCATED_TO', { name: assignTransporter.name, refId: assignTransporter.ref_id }),
              time: assignTransporter.assigned_at,
            });
          }
        });
      } else if (currOrder.timelines && currOrder.timelines.indent_rejected_at) {
        time.push({
          color: 'red',
          type: this.$t('INDENT_REJECTED'),
          time: currOrder.timelines.indent_rejected_at,
          name: `Rejected By ${currOrder.transporter.name}-${currOrder.transporter.ref_id}`,
        });
      }
      if (currOrder && currOrder.flow && currOrder.flow.inspection.accepted) {
        time.push({
          type: this.$t('INDENT_INSPECTION_ACCEPTED'),
          time: currOrder.flow.inspection.inspected_at,
        });
      }
      if (currOrder.assigned_at) {
        time.push({
          type: this.$t('INDENT_VEHICLE_ASSIGNED'),
          time: currOrder.assigned_at,
          name: `${currOrder.timelines && currOrder.timelines.vehicles.length ?
            currOrder.timelines.vehicles[0].number :
            currOrder.vehicle.number} has been assigned`,
        });
      }
      if (currOrder.reported_at) {
        time.push({
          id: 'REPORTED',
          type: this.$t('INDENT_REPORTED'),
          time: currOrder.reported_at,
          unique_id: (currOrder.sources && currOrder.sources[0].unique_id) || '',
        });
      }

      if (currOrder && currOrder.sources) {
        currOrder.sources.forEach((_source) => {
          const gateName = _source.type === 1 ? this.$depot.otherGate(_source.gate_id, _source.location_id).name || '-' : _source.details.name;
          if (_source.arrived_at) {
            time.push({
              id: 'VEHICLE_ARRIVED',
              type: this.$t('INDENT_ARRIVED_AT_GATE', { gate_name: gateName }),
              name: '',
              time: _source.arrived_at,
              unique_id: _source.unique_id,
              created_at: this.order.created_at,
            });
          }
          if (_source.dispatched_at) {
            time.push({
              id: 'DISPATCHED_AT',
              unique_id: _source.unique_id,
              type: this.$t('INDENT_DISPATCHED_AT_GATE', { gate_name: gateName }),
              name: '',
              time: _source.dispatched_at,
            });
          }
        });
      }
      if (currOrder && currOrder.status === 8) {
        if (currOrder.comments &&
          currOrder.comments.cancel &&
          currOrder.comments.cancel.message === 'AUTO_CANCEL_COURIER_SUBTEXT') {
          time.push({
            color: 'red',
            type: this.$t('AUTO_CANCEL_COURIER_COMMENT'),
            name: this.$t('AUTO_CANCEL_COURIER_SUBTEXT') || [],
            time: currOrder.cancelled_at,
          });
          time.push({
            color: 'red',
            type: this.$t('INDENT_INDENT_CANCELLED'),
            name: indentMessage.AUTO_INDENT_CANCEL || [],
            time: currOrder.cancelled_at,
          });
        } else {
          time.push({
            color: 'red',
            type: this.$t('INDENT_INDENT_CANCELLED'),
            name:
              (currOrder.comments &&
                currOrder.comments.cancel &&
                currOrder.comments.cancel.message) ||
              [],
            time: currOrder.cancelled_at,
          });
        }
      }
      if (currOrder && currOrder.destinations) {
        const consigneeMissedCall = currOrder.locationMissedCall.reduce(
          (acc, item) => {
            const result = acc;
            if (item.is_within_destgeofence) {
              result[item.location_id] = item.time_stamp;
            }
            return result;
          },
          {},
        );
        if (this.multiDropAtGateLevel) {
          const destinations = uniqBy(currOrder.destinations, item => [item.location_id, item.gate_id]);
          destinations.forEach((_destination) => {
            if (consigneeMissedCall[_destination.idlocation_id]) {
              time.push({
                type: this.$t('INDENT_CONSIGNEE_MISSED_CALL'),
                name: _destination.details.name,
                time: consigneeMissedCall[_destination.location_id],
              });
            }
            let destinationName = _destination.details.name;
            if (_destination.gate_id) {
              const dropDestinationDetails = this.otherUserDepots.find(val => val.id === _destination.location_id);
              if (dropDestinationDetails && dropDestinationDetails.gates) {
                const gateDetails = dropDestinationDetails.gates.find(gate => gate.id === _destination.gate_id);
                destinationName = `${gateDetails && gateDetails.reference_id} - ${destinationName}`;
              }
            }
            if (_destination.is_not_delivered) {
              time.push({
                color: 'red',
                id: 'INDENT_NOT_DELIVERED',
                unique_id: _destination.unique_id,
                type: this.$t('INDENT_NOT_DELIVERED'),
                name: destinationName,
                time: _destination.reported_at,
                reason: _destination.not_delivered_reason,
              });
            } else {
              if (_destination.reported_at) {
                time.push({
                  id: 'CONSIGNEE_REPORTED_AT',
                  unique_id: _destination.unique_id,
                  type: this.$t('INDENT_CONSIGNEE_REPORTED'),
                  name: destinationName,
                  time: _destination.reported_at,
                });
              }
              if (_destination.unloading_start_at) {
                time.push({
                  id: 'CONSIGNEE_UNLOADING_START_AT',
                  type: this.$t('INDENT_CONSIGNEE_UNLOADING_STARTED'),
                  time: _destination.unloading_start_at,
                  name: destinationName,
                  unique_id: _destination && _destination.unique_id,
                });
              }
              if (_destination.unloading_end_at) {
                time.push({
                  id: 'CONSIGNEE_UNLOADING_END_AT',
                  type: this.$t('INDENT_CONSIGNEE_UNLOADING_ENDED'),
                  time: _destination.unloading_end_at,
                  name: destinationName,
                  unique_id: _destination && _destination.unique_id,
                });
              }
              if (_destination.release_at) {
                time.push({
                  id: 'RELEASED_AT',
                  unique_id: _destination.unique_id,
                  type: this.$t('INDENT_CONSIGNEE_RELEASED'),
                  name: destinationName,
                  time: _destination.release_at,
                });
              }
            }
          });
        } else {
          const destinations = uniqBy(currOrder.destinations, 'location_id');
          destinations.forEach((_destination) => {
            if (_destination.is_not_delivered) {
              time.push({
                color: 'red',
                id: 'INDENT_NOT_DELIVERED',
                unique_id: _destination.unique_id,
                type: this.$t('INDENT_NOT_DELIVERED'),
                name: _destination.details.name,
                time: _destination.reported_at,
                reason: _destination.not_delivered_reason,
              });
            } else {
              if (consigneeMissedCall[_destination.idlocation_id]) {
                time.push({
                  type: this.$t('INDENT_CONSIGNEE_MISSED_CALL'),
                  name: _destination.details.name,
                  time: consigneeMissedCall[_destination.location_id],
                });
              }
              if (_destination.reported_at) {
                time.push({
                  id: 'CONSIGNEE_REPORTED_AT',
                  unique_id: _destination.unique_id,
                  type: this.$t('INDENT_CONSIGNEE_REPORTED'),
                  name: _destination.details.name,
                  time: _destination.reported_at,
                });
              }
              if (_destination.unloading_start_at) {
                time.push({
                  id: 'CONSIGNEE_UNLOADING_START_AT',
                  type: this.$t('INDENT_CONSIGNEE_UNLOADING_STARTED'),
                  time: _destination.unloading_start_at,
                  name: _destination.details.name,
                  unique_id: _destination && _destination.unique_id,
                });
              }
              if (_destination.unloading_end_at) {
                time.push({
                  id: 'CONSIGNEE_UNLOADING_END_AT',
                  type: this.$t('INDENT_CONSIGNEE_UNLOADING_ENDED'),
                  time: _destination.unloading_end_at,
                  name: _destination.details.name,
                  unique_id: _destination && _destination.unique_id,
                });
              }
              if (_destination.release_at) {
                time.push({
                  id: 'RELEASED_AT',
                  unique_id: _destination.unique_id,
                  type: this.$t('INDENT_CONSIGNEE_RELEASED'),
                  name: _destination.details.name,
                  time: _destination.release_at,
                });
              }
            }
          });
        }
      }
      if (this.transporterChangeHistory && this.transporterChangeHistory.length) {
        this.transporterChangeHistory.forEach((changeHistory) => {
          const currentTransporter = changeHistory.assigned_transporter;
          time.push({
            type: this.$t('INDENT_TRANSPORTER_CHANGE_HISTORY'),
            name: this.$t('INDENT_ALLOCATED_TO', { name: currentTransporter.name, refId: currentTransporter.ref_id }),
            time: changeHistory.created_at,
            ...(!isEmpty(changeHistory.updated_by) ? { updated_by: this.$t('INDENT_TRANSPORTER_UPDATED_BY', { updatedBy: changeHistory.updated_by }) } : {}),
          });
        });
      }
      // todo: remove ltr
      // else if (currOrder && currOrder.changedTransporter) {
      //   currOrder.changedTransporter
      //     .sort((a, b) => new Date(a.created_at) - new Date(b.created_at))
      //     .forEach((transporter, index) => {
      //       const previousTransporterName = transporter.name[0];
      //       const currentTransporterName = currOrder.changedTransporter[index + 1]
      //         ? currOrder.changedTransporter[index + 1].name[0]
      //         : (this.order.transporter.name || null);
      //       time.push({
      //         type: this.$t('INDENT_TRANSPORTER_CHANGE_HISTORY'),
      //         name: `${previousTransporterName} to ${currentTransporterName}`,
      //         time: transporter.created_at,
      //       });
      //     });
      // }
      if (currOrder && currOrder.timelines && currOrder.timelines.vehicles.length && currOrder.vehicle.number) {
        time.push({
          type: this.$t('INDENT_VEHICLE_NO_CHANGE_HISTORY'),
          time: currOrder.timelines.vehicles[0].date_on,
          name: `${currOrder.vehicle.number} @ ${this.statusName(
            currOrder.timelines.vehicles[0].indent_status,
          )} status`,
        });
        if (currOrder.timelines.vehicles.length > 1) {
          for (let i = 1; i < currOrder.timelines.vehicles.length; i += 1) {
            time.push({
              type: this.$t('INDENT_VEHICLE_NO_CHANGE_HISTORY'),
              name: `changed to ${currOrder.timelines.vehicles[i].number} @ ${this.statusName(
                currOrder.timelines.vehicles[i].indent_status,
              )} status`,
              time: currOrder.timelines.vehicles[i].date_on,
            });
          }
        }
      }
      if (currOrder && currOrder.timelines && currOrder.timelines.rejections) {
        currOrder.timelines.rejections.forEach((timeline) => {
          time.push({
            color: 'red',
            type: this.$t('INDENT_REJECTION_TRUCK'),
            name: `${timeline.vehicle_number} @ ${this.statusName(
              timeline.indent_status,
            )}`,
            time: timeline.date_on,
          });
        });
      }

      if (currOrder && currOrder.label_details && currOrder.label_details.status === 'CANCEL') {
        time.push({
          type: this.$t('INDENT_CARRIER_BOOKING_CANCELLED'),
          name: this.$t('INDENT_CARRIER_BOOKING_CANCELLED_FOR_TRACKING_NUMBER', { tracking_number: currOrder.label_details.tracking_number }),
          time: currOrder.label_details.cancelled_date,
        });
      }
      if (this.integrationTimeLine && this.integrationTimeLine.length) {
        this.integrationTimeLine.forEach((_data) => {
          time.push({
            type: this.$t(`${_data.type}`) || _data.type,
            // name: this.$t(`${_data.type}`) || _data.type,
            time: _data.created_at,
            statusCode: _data.response_code,
            response: _data.response,
          });
        });
      }
      if (this.changeTruckComments && this.changeTruckComments.length) {
        this.changeTruckComments.forEach((_data) => {
          time.push({
            type: this.$t('INDENT_REMARKS_ADDED'),
            name: _data.user.name,
            time: _data.created_date,
          });
        });
      }
      if (currOrder && currOrder.bid_expiry_extension_history) {
        currOrder.bid_expiry_extension_history.forEach((_data) => {
          const timeDetails = {};
          if (this.configurations.is_datepicker_24H_enabled) {
            timeDetails.from = moment(_data.previous_bid_expiry_time).format('HH:mm A');
            timeDetails.to = moment(_data.extended_bid_expiry_time).format('HH:mm A');
          } else {
            timeDetails.from = moment(_data.previous_bid_expiry_time).format('hh:mm A');
            timeDetails.to = moment(_data.extended_bid_expiry_time).format('hh:mm A');
          }
          time.push({
            type: this.$t('AUTO_EXTEND_BID_EXPIRY'),
            name: this.$t('AUTO_EXTEND_BID_EXPIRY_TIMELINE', timeDetails),
            time: _data.bid_expiry_extended_at,
          });
        });
      }
      return orderBy(time, ['time']);
      // time.sort((a, b) => new Date(a.time) - new Date(b.time));
    },
    destinations() {
      if (this.order.order_status == 1) {
        const accessDestinations =
        this.order.destinations &&
        this.order.destinations.filter(this.hasUserDepotAccess);
        if (this.multiDropAtGateLevel) {
          return uniqBy(accessDestinations, v => [v.location_id, v.gate_id].join());
        }
        return uniqBy(accessDestinations, 'location_id');
      }
      if (this.multiDropAtGateLevel && this.order.destinations) {
        return uniqBy(this.order.destinations, v => [v.location_id, v.gate_id].join());
      }
      return (
        this.order.destinations &&
        uniqBy(this.order.destinations, 'location_id')
      );
    },
  },
  methods: {
    getClass(event) {
      if (event.color) {
        return 'dot-red';
      }
      return 'dot-purple';
    },
    async delay(ms) {
      return new Promise(res => setTimeout(res, ms));
    },
    isBookingCancelled(booking) {
      return (booking.status === courierServiceAction().CANCEL);
    },
    backToListing() {
      this.isFetchOpen = null;
      this.approvalList = [];
    },
    getClassName(booking) {
      return this.isBookingCancelled(booking) ? 'text-red3' : '';
    },
    getBookingStatus(booking) {
      return this.isBookingCancelled(booking) ? 'BOOKING CANCELLED' : (booking.last_tracking_status || '-');
    },
    async fetchTransporterChangeHistory() {
      try {
        const id = this.order.order_number;
        const result = await this.$store.dispatch('order/getTransporterChangeHistory', {
          id,
        });
        if (result.error) {
          this.$error({ message: result.error });
        } else {
          this.transporterChangeHistory = result;
        }
      } catch (err) {
        this.$error({
          message: this.$t('INDENT_TRACKING_FETCH_FAILS'),
        });
      }
    },
    getCourierDetails(consignee) {
      if (this.activeConsigneeId && consignee.consignee_id === this.activeConsigneeId) {
        this.activeConsigneeId = null;
        return;
      }
      this.activeConsigneeId = consignee.consignee_id;
    },
    hasEnabled(consignee) {
      return this.activeConsigneeId === consignee.consignee_id;
    },
    async fetchCourierTrackingList() {
      try {
        const id = this.order.order_number;
        const result = await this.$store.dispatch('order/trackingList', {
          id,
        });
        if (result.error) {
          this.$error({ message: result.error });
        }
      } catch (err) {
        this.$error({
          message: this.$t('INDENT_TRACKING_FETCH_FAILS'),
        });
      }
    },
    async retriggerBooking(consignment) {
      try {
        const orderNo = this.order.order_number;
        const destinationId = consignment.id;
        const result = await this.$store.dispatch(
          'order/retriggerCourierBooking',
          {
            destinationId,
            orderNo,
          },
        );
        if (result.status === 204) {
          this.$success({ message: this.$t('INDENT_RETRIGGER_BOOKING_SUCCESSFUL') });
        }
        if (result.error) {
          this.$error({ message: result.error });
        }
      } catch (err) {
        this.$error({
          message: this.$t('INDENT_RETRIGGER_FAILS'),
        });
      }
    },
    async fetchApprovalTimeline() {
      const type = this.order.approval_event_type;
      const { ApprovalEventTypes } = ApprovalConstants;
      const invertedMap = invert(ApprovalEventTypes);
      this.eventType = invertedMap[type];
      this.isFetchOpen = 'approvals';
      const result = await this.$store.dispatch(
        'order/approvalTimeline',
        {
          entity_id: this.order.id,
          event_type: type,
        },
      );

      const sortByTime = result.sort((a, b) => new Date(b.date_time) - new Date(a.date_time));

      this.approvalList = sortByTime.map(event => ({
        type: event.label,
        time: event.date_time,
        name: event.message,
        remarks: event.remarks ? `Reason: ${event.remarks}` : '',
        status: event.status,
      }));
    },
    async fetchTracking(consignment) {
      try {
        const id = this.order.order_number;
        this.isFetchOpen = 'tracking';
        this.currentTrackingId = consignment.tracking_id;
        const result = await this.$store.dispatch(
          'order/consignmentTrackList',
          {
            consignment,
            id,
          },
        );
        await this.fetchCourierTrackingList();
        if (result.error) {
          this.$error({ message: result.error });
        }
      } catch (err) {
        this.$error({
          message: this.$t('INDENT_CONSIGNMENT_TRACKING_FETCH_FAILS'),
        });
      }
    },
    clearTrackingNo(order) {
      this.tracking_no = '';
      this.showEditIcons = false;
    },
    editTrackinNumber() {
      // 29 - Ship ready, 0 - Indented
      if (this.order.status === 29 || this.order.status === 0) {
        return false;
      }
      return true;
    },
    async saveTrackingNo(order) {
      try {
        const id = this.order.order_number;
        const result = await this.$store.dispatch('order/saveIndentTrackingNo', {
          id,
          trackingNo: this.tracking_no,
        });
        if (result.status && result.status === 'Success') {
          this.trackingVal = this.tracking_no;
          this.showEditIcons = false;
          this.$success({ message: this.$t('INDENT_TRACKING_NUMBER_SAVED') });
        } else if (result.error) {
          this.showEditIcons = false;
          this.$error({ message: result.error });
        }
        return 'done';
      } catch (error) {
        return error;
      }
    },
    statusName(id) {
      const mainStatus = this.$statusUtil.mainStatus;
      const mainStatusId = this.$statusUtil.getMainStatusId(id);
      return mainStatus.find(status => status.id === mainStatusId).label;
    },
    accordian() {
      this.isActive = !this.isActive;
    },
    showEditIconsView(event) {
      this.showEditIcons = true;
    },
    hasUserDepotAccess(destination) {
      const hasDepotAccess =
      this.currentUserDepots && this.currentUserDepots.length;
      const depotIds = this.currentUserDepots.map(_depot => _depot.id);
      return destination.type === this.sectionType.DEPOT &&
      hasDepotAccess ? depotIds.includes(destination.location_id) : true;
    },
    parseLegalEntity(trackingData) {
      const defaultLegalEntity = 'Default LE';
      const legalEntities = trackingData.legal_entity && trackingData.legal_entity.split('-');
      if (legalEntities && legalEntities.length >= 2) {
        if (legalEntities[0] === defaultLegalEntity) {
          legalEntities[0] = trackingData.source_name || defaultLegalEntity;
        }
        if (legalEntities[1] === defaultLegalEntity) {
          legalEntities[1] = trackingData.consignee_name || defaultLegalEntity;
        }
        return legalEntities;
      }
      return ['-', '-'];
    },
    getBookingMapKeys(booking, lrDetails, multiDropAtGateLevel, isGateWise = false) {
      let key = booking.location_id;

      if (multiDropAtGateLevel) {
        key = `${key}_${booking.consignee_id}`;
      }

      if (lrDetails.legal_entity) {
        key = `${key}_${booking.legal_entity}`;
      } else if (lrDetails.division_id) {
        key = `${key}_${booking.division}`;
      } else if (lrDetails.source_gate_id || isGateWise) {
        key = `${key}_${booking.source_gate_id || ''}`;
      }

      return key;
    },
  },
};
</script>

<style lang="scss" scoped>
.trackno-text {
  background-color: transparent;
  width: 190px;
  margin-right: 10px;
  border: none;
  &:focus {
    outline: none;
  }
  .order-timeline {
    font-size: 14px;
  }
  .timelinecontentdiv {
    margin: 0 0 10px 0;
    line-height: 22px;
    b {
      color: #646464;
    }
  }
}
</style>
